import React from 'react';
import { Route } from 'react-router-dom';
import PrivateRoute from 'src/routes/PrivateRoute';
import { DynamicCampaignV2Page } from '../pages';

const builderPaths = [
  '/campaign-builder/:configIdOrType/:campaignId',
  '/campaign-builder/:configIdOrType',
  '/campaign-builder',
  '/campaign-builder-v2/:configIdOrType/:campaignId',
  '/campaign-builder-v2/:configIdOrType',
  '/campaign-builder-v2',
];

export const routes = (
  <>
    {builderPaths.map(path => (
      <Route
        key={path}
        path={path}
        element={
          <PrivateRoute>
            <DynamicCampaignV2Page />
          </PrivateRoute>
        }
      />
    ))}
  </>
);
